"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSustainableSolutions = function IconSustainableSolutions(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m35.324 4.417-2-2-.707.707 2 2zm.53.42 1.272 1.545a3 3 0 1 0 3.995 4.47l.137-.142 1.484 1.34a5 5 0 1 1-7.064-7.06zM24 6v6h5v4h2v27H16v-2h9v-3a3 3 0 0 0-2.824-2.995L22 35H6v-2h16a5 5 0 0 1 4.995 4.783L27 38v3h2V18H16v8h-2v-4H7v4H5v-6h9v-4h2v-4h6V6zm3 10v-2h-9v2zm-6 9v-4h-2v4zm5-4v4h-2v-4zm-1 8v1H2v-1zm-10 9v-1h-5v1zm7-1v1h-5v-1zm17 6v-4.058a4.79 4.79 0 0 0 3.998-4.999C43 30.016 40.838 24 38 24s-5 6.015-5 10c-.076 1.306.431 2.638 1.397 3.603l.185.176A4.8 4.8 0 0 0 37 38.942V43zm1.19-6.811a2.8 2.8 0 0 1-1.788.811h-.804a2.79 2.79 0 0 1-2.604-2.745l.004-.198C35 31.074 36.824 26 38 26c1.15 0 2.917 4.846 2.997 7.797L41 34c.047.851-.249 1.627-.81 2.189M39 19v-4h-1v4zM33 8v1h-4V8zm2.324 5.124-.707-.708-2 2 .707.708zm8-.708 2 2-.707.708-2-2z",
    clipRule: "evenodd"
  })));
};

export { IconSustainableSolutions, IconSustainableSolutions as default };
